export default __webpack_public_path__ + "static/media/IMG_0957.0f169fb6.jpg";